'use client';

import { useEffect } from 'react';

import { findProjectBySlug } from '@shaojiang/data/profile';
import { useProfileStore } from '@shaojiang/store/profile';

/** Opens the details dialog for /projects/[slug] deep links. */
export default function LoadProject({ slug }: { slug: string }) {
  const setCurrentProject = useProfileStore((state) => state.setCurrentProject);

  useEffect(() => {
    const project = findProjectBySlug(slug);
    if (project) {
      setCurrentProject(project);
    }
  }, [setCurrentProject, slug]);

  return null;
}
